import { render, staticRenderFns } from "./FormVisit.vue?vue&type=template&id=843e2b20"
import script from "./FormVisit.vue?vue&type=script&lang=js"
export * from "./FormVisit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports